import React, { useMemo, useRef, useCallback } from 'react';
import styled from 'styled-components/macro';

import useMediaStore from '../../../../../common/store/useMediaStore';
import useFlavorStore from '../../../../../common/store/useFlavorStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useParallax from '../../useParallax';
import useAnimation from './useAnimation';

const Flower = styled.img`
  aspect-ratio: 497/703;
  transform: translateY(-50%);
`;

const Lime = styled.img`
  aspect-ratio: 157/150;
  width: 120rem;
  height: auto;
`;

const Elderflower = () => {
  /**
   * Hooks
   */
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));
  const md = useMediaStore(useCallback(state => state.md, []));

  const ref = {
    figure: {
      flower: useRef<HTMLElement>(null),
      lime: useRef<HTMLElement>(null)
    },
    img: {
      lime: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    flower: useMemo(() => getVh("flavor", 0.5), []),
    lime: useMemo(() => getVh("flavor", 0.75), [])
  }

  useAnimation(flavor === "elderflower", [ref.figure.flower, ref.figure.lime]);
  useParallax(ref.img.lime, top.lime, 150);

  /**
   * Not hook
   */
  const style = !md ? { left: "45vw" } : { right: "-175rem" };

  /**
   * Render
   */
  return (
    <>
      <Container
        ref={ref.figure.flower}
        top={top.flower}
        style={{ ...style }}
      >
        <Flower src="/static/images/fill/elderflower.png" />
      </Container>

      <Container
        ref={ref.figure.lime}
        top={top.lime}
        style={{ left: "40vw" }}
      >
        <Lime
          ref={ref.img.lime}
          src="/static/images/fill/lime/1.png"
        />
      </Container>
    </>
  )

}

export default Elderflower;